const TherapistCardSkeleton: React.FC = () => (
  <div
    className="flex h-full flex-col rounded-[1.75rem] bg-white p-6 shadow-[0_18px_40px_rgba(58,88,89,0.08)]"
    aria-hidden="true"
  >
    <div className="mx-auto h-20 w-20 animate-pulse rounded-full bg-[#E8EFEB]" />
    <div className="mx-auto mt-4 h-5 w-40 animate-pulse rounded-full bg-[#E8EFEB]" />
    <div className="mx-auto mt-2 h-4 w-28 animate-pulse rounded-full bg-[#F0F4F1]" />
    <div className="mt-6 space-y-2">
      <div className="h-3 w-full animate-pulse rounded bg-[#F0F4F1]" />
      <div className="h-3 w-full animate-pulse rounded bg-[#F0F4F1]" />
      <div className="h-3 w-4/5 animate-pulse rounded bg-[#F0F4F1]" />
    </div>
    <div className="mt-6 h-10 w-full animate-pulse rounded-full bg-[#D5E1DB]" />
  </div>
);

export default TherapistCardSkeleton;
